class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    document.body.addEventListener('click', (event) => {
      const cartLink = event.target.closest('#cart-icon-bubble');

      if (cartLink) {
        event.preventDefault();
        this.open(cartLink);
      }
    });

    document.body.addEventListener('keydown', (event) => {
      const cartLink = event.target.closest('#cart-icon-bubble');

      if (cartLink && event.target === cartLink && event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (cartLink) {
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
    }
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

// Listen for Upnova cart add requests and trigger cart drawer
document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('cart-drawer');
  const originalFetch = window.fetch;

  window.fetch = function(url, options) {
    const urlString = url.toString();
    const isUpnovaCartAdd = urlString.includes('/cart/add.js?app=upez');

    if (isUpnovaCartAdd) {
      return originalFetch.apply(this, [url, options]).then((response) => {
        setTimeout(() => {
          fetch(`${routes.root_url}`)
            .then(response => response.text())
            .then(responseText => {
              const html = new DOMParser().parseFromString(responseText, "text/html");

              // Update cart drawer
              const sourceDrawer = html.querySelector(".drawer__inner");
              const targetDrawer = document.querySelector(".drawer__inner");
              if (sourceDrawer && targetDrawer) {
                targetDrawer.innerHTML = sourceDrawer.innerHTML;
              }

              // Update header cart icon bubble
              const sourceHeaderCartIconBubble = html.querySelector(".header__icon--cart");
              const targetHeaderCartIconBubble = document.querySelector(".header__icon--cart");
              if (sourceHeaderCartIconBubble && targetHeaderCartIconBubble) {
                targetHeaderCartIconBubble.innerHTML = sourceHeaderCartIconBubble.innerHTML;
              }

              drawer.classList.remove('is-empty');
              drawer.open();
            })
            .catch((e) => {
              console.error(e);
            });
        }, 1000);
        return response;
      });
    }

    return originalFetch.apply(this, [url, options]);
  };
});